import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DateInput.html?raw';
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';

import docu from './DateInputDocumentation.html?raw';
import { AccessibilityLabelsHelper } from "../../../more/Helpers";



type DateMode = "ymd" | "ym" | "dmy" | "my" | "date" | "month";
class DateInput extends compose(_LabelInputBase) {
    templateString: any = template;

    inputNode: HTMLInputElement;
    labelNode: HTMLLabelElement;
    errorMsgNode: HTMLSpanElement;
    validationMsgNodeContainer = "errorMsgNode";
    validationEnabled = true;

    private inputWeekdayNode: HTMLInputElement;
    private useWeekdayView: boolean = false;

    protected highlightOnEmptyValue: boolean = false;
    protected _manualHighlightOverride: boolean = false;

    minValue: Date;
    //maxValue: Date = new Date(9999,11,31); // nicht setzen weil chrome dann keinen wechsel auf eine 5. stelle zulässt und dadurch nie auf das aktuelle jahr springt
    maxValue: Date;

    private _mode: "month" | "date" = "date";
    private _validRawValue: string = null;

    _value: Date; // current Date object

    // Methods

    focus() {
        this.inputNode.focus();
    }
    protected _setReadonlyStyle() {
        if (this.isReadonly === true) {
            this.UiModder.domAttr.set(this.inputNode, "disabled", "");
            this.UiModder.domAttr.set(this.inputWeekdayNode, "disabled", "");
        } else {
            this.UiModder.domAttr.remove(this.inputNode, "disabled");
            this.UiModder.domAttr.remove(this.inputWeekdayNode, "disabled");
        }

        if (this.labelNode) {
            this.UiModder.domClass.toggle(this.labelNode, "w3-disabled", this.isReadonly);
        }
        if (this.inputWeekdayNode) {
            this.UiModder.domClass.toggle(this.inputWeekdayNode, "w3-disabled", this.isReadonly);
        }
    }

    private _onInput_InputNode(): void {

        //console.debug("dateInput _onInput_InputNode", this.inputNode.value, this._value);
        if (this.inputNode.value == null || this.inputNode.value == "") {
            this.setValue(null);
            this._onChange_InputNode();
            return;
        }
        if (Object.prototype.toString.call(new Date(this.inputNode.value)) === "[object Date]") {
            if (new Date(this.inputNode.value).getFullYear().toString().length == 4) {
                this._onChange_InputNode();
            } else {
                if (this.inputNode.value.length >= 10) {
                    let parts = this.inputNode.value.split("-");
                    let year = parts[0];
                    let month = parts[1];
                    let day = parts[2];
                    if (parseInt(year) > 9999) {
                        year = (new Date()).getFullYear().toString();
                        this.inputNode.value = `${year}-${month}-${day}`;
                    }
                    //console.log("so a bledsinn 2", this.inputNode.value);
                }
            }
        }
    }


    private _onKeyUp_Inputnode(evt: KeyboardEvent): void {
        //console.debug(this.id + " _onKeyUp_Inputnode", evt.key, this._valueEmitted, this._valueCommitted);
        if (this.isReadonly) return;

        if (evt.key == "Enter") {
            //this._onChange_InputNode(); // dauert zu lange - weil this.isFocused auf true steht und deshalb delay etc
            //this.inputNode.blur(); // komplett rausspringen und das Blur auslösen
            this._onBlur(evt); // oder nur so tun als obs ein Blur wär (Cursort bleibt im Feld)
            this.emit("enterKey");
            return;
        } else if (evt.key == "Escape") {
            this.setValue(this._valueCommitted, this._valueEmitted != this._valueCommitted);
            this.inputNode.blur();
            this.emit("keyUp", evt);
            return;
        }
        let rawValue = this.inputNode.value;

        if (rawValue?.length >= 6) {

            // sobald die Eingabe ein komplettes gültiges Datum ist:
            let valueObj = new Date(this.inputNode.value);
            if (Object.prototype.toString.call(valueObj) === "[object Date]") {
                if (valueObj.getFullYear().toString().length == 4) {
                    this._onChange_InputNode();
                    //this.setValue(valueObj);
                }
            }
        }

        //this.emit("keyUpDateInput", evt); // nicht genutzt...
        this.emit("keyUp", evt);
    }

    private _onClick_Inputnode(evt: MouseEvent) {
        evt.stopPropagation();
    //    console.debug("dateInput _onClick_Inputnode", this.inputNode.value, this._value);
    //    this._onChange_InputNode(); // manche Browser scheinen beim "Löschen" kein Changeevent auszulösen?!
    }

    private _onChange_InputNode(evt?: Event): void {
        //console.debug("dateInput _onChange_InputNode", this.inputNode.value, this._value);
        if (this.inputNode.value == null || this.inputNode.value == "") {
            this.setValue(null);
            if (this.useWeekdayView) this.setWeekdayShortValue(null);
            return;
        }

        let valueObj = new Date(this.inputNode.value);
        let rawValue = this.inputNode.value;
        if (rawValue?.length >= 6) {
            if (Object.prototype.toString.call(valueObj) === "[object Date]") {
                if (valueObj.getFullYear().toString().length == 4) {
                    this.setValue(valueObj);
                    if (this.useWeekdayView) this.setWeekdayShortValue(valueObj);
                    return;
                }
            }
        }

        this.setValue(null);
    }

    setFormat(mode: DateMode) {
        if (!mode) return;

        let newMode = mode.toLowerCase() as DateMode;
        let targetMode = this._mode;

        switch (newMode) {
            case "ymd":
            case "date":
            case "dmy":
                targetMode = "date";
                break;
            case "my":
            case "month":
            case "ym":
                targetMode = "month";
                break;
        }

        if (this._mode != targetMode) {
            this._mode = targetMode;


            switch (this._mode) {
                case "date":
                    this.UiModder.domAttr.set(this.inputNode, "type", "date");
                    this.setInputValue();
                    break;
                case "month":
                    this.UiModder.domAttr.set(this.inputNode, "type", "month");
                    this.setInputValue();
                    break;
            }
        }
    }

    private _setFormatAttr(mode: DateMode) {
        this.setFormat(mode);
    }
    private _setModeAttr(mode: DateMode) {
        this.setFormat(mode);
    }

    setUseWeekdayView(useWeekday: boolean) {

        this.useWeekdayView = useWeekday;

        this.hideNode(this.inputWeekdayNode, useWeekday !== true)
    }
    private _setUseWeekdayViewAttr(useWeekday: boolean) {
        this.setUseWeekdayView(useWeekday);
    }

    private setWeekdayShortValue(date: Date) {

        if (!date) {
            this.inputWeekdayNode.value = null;
            return;
        }

        this.inputWeekdayNode.value = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"][date.getDay()];
    }

    setValue(newValue: any, suppressChangeEvent: boolean = false): void {
        let oldValue_str: string = "";
        let newValue_str: string = "";
        let newValueDate: Date = null;

        if (this._value) {
            oldValue_str = this.toStringISO(this._value).slice(0, 16);
        }

        //console.debug("DateInput - set value", newValue, this._value, oldValue_str);

        if (typeof newValue == 'string' && newValue) {

            let shouldBeDate = new Date(newValue.slice(0, 10));

            if (shouldBeDate && Object.prototype.toString.call(shouldBeDate) === "[object Date]") {
                if (!isNaN(shouldBeDate.getFullYear())) {
                    newValueDate = shouldBeDate;
                } else {
                    console.warn("Invalid Date_String Format!", newValue)
                }
            } else {
                console.warn("Invalid Date_String Format!")
            }
        }
        else if (Object.prototype.toString.call(newValue) === "[object Date]" && !isNaN(newValue.getFullYear())) { // Value is a valid Date Object
            newValueDate = newValue;
        }

        if (newValueDate) {
            newValue_str = this.toStringISO(newValueDate).slice(0, 16);
        }

        //console.debug(this.id + " setValue: old, new", oldValue_str, newValue_str);

        let actuallyChanged = oldValue_str != newValue_str;

        if (actuallyChanged) {
            this._value = newValueDate;

            this.setInputValue();

            if (!suppressChangeEvent) {
                this.__delayValueChangeEmit();
            } else {

                if (this.useWeekdayView) this.setWeekdayShortValue(this._value);
            }
        }

        // #########




        if (this.validateInput()) this._validRawValue = this.inputNode.value;

    }

    protected setInputValue(): void {

        //console.debug("DateInput - set input", this._value);
        if (this._value) {

            let day = ("0" + this._value.getDate()).slice(-2); //DD
            let month = ("0" + (this._value.getMonth() + 1)).slice(-2); //MM
            let year = this._value.getFullYear() //YYYY

            switch (this._mode) {
                case "month":
                    this.inputNode.value = `${year}-${month}`; // yyyy-MM offizielles Format
                    break;

                case "date":
                default:
                    this.inputNode.value = `${year}-${month}-${day}`
                    break;
            }

        } else if (this._value == null || !this._value) {
            this.inputNode.value = "";
        }
    }

    toStringISO(date: Date): string {

        if (date && Object.prototype.toString.call(date) === "[object Date]") {

            if (isNaN(date.getFullYear())) {
                return null;
            }

            let day = ("0" + date.getDate()).slice(-2); //DD
            let month = ("0" + (date.getMonth() + 1)).slice(-2); //MM
            let year = date.getFullYear() //YYYY
            let hours = ("0" + date.getHours()).slice(-2); // HH
            let min = ("0" + date.getMinutes()).slice(-2);  // mm
            let sec = ("0" + date.getSeconds()).slice(-2); // ss

            // YYYY-MM-DDTHH:mm:ss
            let ISOString = `${year}-${month}-${day}T${hours}:${min}:${sec}`;
            return ISOString;
        }

        return "";
    }

    // Label



    // Validation

    protected customValidation(): boolean {

        //wir checkn mit dieser method ob das datum valide ist (also kein date rollover) & ob die mssql bounds nicht ueberschlagen werden
        let result = this.checkBaseDateConstraints();


        let data: Date|undefined = this._value;
        let dataIsDate = Object.prototype.toString.call(data) === "[object Date]";

        if (data && dataIsDate) {

            if (isNaN(data.getFullYear())) {
                result = false;
            }
        }else if (this.isMandatory) {

            //this.validationErrorMsgText = window.translations['Generic__mandatory'];
            result = false;
        }

        if (result && dataIsDate) {
            if (this.minValue) {
                if (data.getTime() < this.minValue.getTime()) {
                    result = false;
                }
            }

            if (this.maxValue) {
                if (data.getTime() > this.maxValue.getTime()) {
                    result = false;
                }
            }
        }


        if (result == true) {
            this._validRawValue = this.inputNode.value;
        }

        return result;

    }

    /**
     * Ueberprueft ob ein Datum ein rollover im Date Objekt ausloesen wuerde.
     * Als Zusatz wird auch auf hard Limits fuer die DB ueberprueft.
     * Diese Methode dient nur als Grundabsicherung.
     * @param minIsoDate ISO Str fuer min. Erlaubtes Datum (am besten DB hard limit)
     * @param maxIsoDate ISO Str fuer max. Erlaubtes Datum (am besten DB hard limit)
     * @returns Ob this.inputNode ein Valides Datum gesetzt hat
     */
    private checkBaseDateConstraints(minIsoDate: string = "1753-01-01", maxIsoDate: string = "9999-12-31"): boolean {
        // 1753-01-01 & 9999-12-31 sind mssql datetime hard limits
        const dateStr:string = this.inputNode.value;
        if (!dateStr){
            if (this.isMandatory == false){
                return true; //is wurscht wenn nicht mandatory, wenn date str leer ist...
            }
            return false;
        }

        const isoRegex = /^\d{4}-\d{2}-\d{2}$/;
        if (!isoRegex.test(dateStr)) { //browser gibt muell format zurueck?!? sollte eigentlich nur durch addons oder browser update/break passieren
            console.error("dateinput: invalid date format (not YYYY-MM-DD), browser compatibility error?!?");
            return false;
        }

        const parts = dateStr.split('-').map(part => parseInt(part, 10));
        const year = parts[0];
        const month = parts[1];
        const day = parts[2];
        const date = new Date(year, month - 1, day);

        if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
            console.warn("dateinput: invalid date typed (date rollover detected)");
            return false;
        }

        if (minIsoDate && dateStr < minIsoDate) {
            console.warn("dateinput: hard limit min reached");
            return false;
        }

        if (maxIsoDate && dateStr > maxIsoDate) {
            console.warn("dateinput: hard limit max reached");
            return false;
        }

        return true;
    }

    private _setMinAttr(value: string) {
        if (!value) this.setMinValue(null);
        else {
            let valueDate = new Date(value);
            if (valueDate && valueDate.getFullYear) {
                this.setMinValue(valueDate);
            }
        }
    }
    setMinValue(value: Date) {
        if (!value) {
            this.maxValue = null;
            this.UiModder.domAttr.remove(this.inputNode, "min");
            this.setValidationEnabled(this.isMandatory || !!this.maxValue);

        } else if (value && Object.prototype.toString.call(value) === "[object Date]") {

            if (isNaN(value.getFullYear())) {
                return null;
            }

            this.minValue = value;

            let day = ("0" + value.getDate()).slice(-2); //DD
            let month = ("0" + (value.getMonth() + 1)).slice(-2); //MM
            let year = value.getFullYear() //YYYY

            // YYYY-MM-DDTHH:mm:ss
            let inputAttrString = `${year}-${month}-${day}`;
            if (this._mode == "month") {
                inputAttrString = `${year}-${month}`;
            }

            this.UiModder.domAttr.set(this.inputNode, "min", inputAttrString);
            this.setValidationEnabled(true);
        }
    }
    private _setMaxAttr(value: string) {
        if (!value) this.setMaxValue(null);
        else {
            let valueDate = new Date(value);
            if (valueDate && valueDate.getFullYear) {
                this.setMaxValue(valueDate);
            }
        }
    }
    setMaxValue(value: Date) {

        if (!value) {
            this.maxValue = null;
            this.UiModder.domAttr.remove(this.inputNode, "max");
            this.setValidationEnabled(this.isMandatory || !!this.minValue);
        }
        else if (value && Object.prototype.toString.call(value) === "[object Date]") {

            if (isNaN(value.getFullYear())) {
                return null;
            }

            this.maxValue = value;

            let day = ("0" + value.getDate()).slice(-2); //DD
            let month = ("0" + (value.getMonth() + 1)).slice(-2); //MM
            let year = value.getFullYear() //YYYY

            // YYYY-MM-DDTHH:mm:ss
            let inputAttrString = `${year}-${month}-${day}`;
            if (this._mode == "month") {
                inputAttrString = `${year}-${month}`;
            }

            this.UiModder.domAttr.set(this.inputNode, "max", inputAttrString);

            this.setValidationEnabled(true);
        }
    }

    // Doku
    getDocumentationContent(): string {
        return docu;
    }

    // Dojo



    public setAllDataCyAttributes() {
        super.setAllDataCyAttributes.apply(this, arguments as any);
        this.setDataCyAttribute(this.inputWeekdayNode, "inputWeekday");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.domNode.addEventListener("click", lang.hitch(this, function (evt) { evt.stopPropagation() }));

        if (this.maxValue != null) {
            this.setMaxValue(this.maxValue);
        }
        this.inputNode.addEventListener('blur', lang.hitch(this, this.validateInput));

        AccessibilityLabelsHelper.LabelForInputBind(this.id, this.inputNode, "dateInput", this.labelNode);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
        //this.setValue("2020-08-03T02:00:00");
    }
}

export default mdsWidget(DateInput);
